const { __ } = wp.i18n;
const { Fragment, useState, useRef, useEffect } = wp.element;
const { select } = wp.data;
import { produce } from "immer";

// import axios from "axios";
import BControls from "./BControls";
// import BRangeControl from "./BRangeControl";
import Settings from "./Tabs/General/Settings";
import Overlay from "./Tabs/General/Overlay";
import Subtitle from "./Tabs/General/Subtitle";
import Quality from "./Tabs/General/Quality";
import Watermark from "./Tabs/General/Watermark";
import Popup from "./Tabs/General/Popup";
import panelBodyController from "../../../../wp-utils/v1/panelBodyController";
import EndScreen from "./Tabs/General/EndScreen";
import RefactorDataStructure from "./RefactorDataStructure";
import Markers from "./Tabs/General/Markers";
import BControlPro from "../../components/BControlPro";
import PasswordProtected from "./Tabs/General/PasswordProtected";
// import Styles from "./Styles";

const { TabPanel, Panel, PanelBody, PanelRow, TextControl, TextareaControl, __experimentalUnitControl: UnitControl } = wp.components;
const { InspectorControls } = wp.blockEditor;
const { getCurrentPostId } = select("core/editor");

const BSettings = ({ attributes, setAttributes, clientId, isPremium, name }) => {
  const { styles, source } = attributes;
  const { plyr_wrapper } = styles;

  useEffect(() => {
    setAttributes({ uniqueId: `h5vp${clientId.substr(0, 8)}` });
  }, []);

  const postId = getCurrentPostId();

  const { additionalCSS, additionalID, options } = attributes;
  const { speed } = options;

  const postType = select("core/editor").getCurrentPostType();
  const panelRef = useRef(null);

  const updateOption = (value, type = null) => {
    updateHandler(value, type, "options");
  };

  const updateFeatures = (value, type = null) => {
    updateHandler(value, type, "features");
  };

  const updateStyle = (value, type = null) => {
    updateHandler(value, type, "styles");
  };

  const updateHandler = (value, type, attr) => {
    setAttributes({
      [attr]: produce(attributes[attr], (draft) => {
        Object.keys(value).map((key) => {
          if (type) {
            if (draft[type]) {
              draft[type][key] = value[key];
            } else {
              draft[type] = { [key]: value };
            }
          } else {
            draft[key] = value[key];
          }
        });
      }),
    });
  };

  const handleUnitChange = (unit) => {
    if (unit === "%") {
      updateStyle({ width: "100%" }, "plyr_wrapper");
    }
    if (unit === "px") {
      updateStyle({ width: "500px" }, "plyr_wrapper");
    }

    if (["rem", "vh", "hw"].includes(unit)) {
      updateStyle({ width: 100 + unit }, "plyr_wrapper");
    }
  };

  return (
    <Fragment>
      {/* <Styles attributes={attributes} setAttributes={setAttributes} /> */}
      <InspectorControls style={{ marginBottom: "40px" }}>
        {postType === "videoplayer" && (
          <PanelBody>
            <PanelRow>
              <div className="h5vp_front_shortcode">
                <input value={`[html5_video id=${postId}]`} />
                <span className="htooltip">{__("Copy To Clipboard", "h5vp")}</span>
              </div>
            </PanelRow>
          </PanelBody>
        )}

        {/* {!poster && !streaming && (
          <div className="generateThumbButton">
            {
              // <img src={loadingImg} />
            }
            <Button className="button button-primary" onClick={generateThumb}>
              {__("Generate Thumbnail", "h5vp")}
            </Button>
            <p>{__("(Experimental)", "h5vp")}</p>
          </div>
        )} */}

        <TabPanel
          className="bPSS"
          activeClass="active-tab"
          onSelect={panelBodyController}
          tabs={[
            {
              name: "general",
              title: "General",
              className: "general btTab",
            },
            {
              name: "controls",
              title: "Controls",
              className: "slider btTab",
            },
            {
              name: "style",
              title: "Style",
              className: "style btTab",
            },
          ]}
        >
          {(tab) => {
            return (
              <span>
                <RefactorDataStructure attributes={attributes} setAttributes={setAttributes} />
                {tab.name == "general" && (
                  <span>
                    <Panel>
                      {/* {Settings } */}
                      <Settings name={name} isPremium={isPremium} attributes={attributes} setAttributes={setAttributes} handleOptions={updateOption} handleFeatures={updateFeatures} />
                      <Markers isPremium={isPremium} attributes={attributes} setAttributes={setAttributes} panelRef={panelRef} handleOptions={updateOption} />

                      {/* {overlay tab} */}
                      <Overlay isPremium={isPremium} attributes={attributes} setAttributes={setAttributes} handleFeatures={updateFeatures} />

                      <EndScreen isPremium={isPremium} attributes={attributes} setAttributes={setAttributes} panelRef={panelRef} handleFeatures={updateFeatures} />

                      <PasswordProtected isPremium={isPremium} attributes={attributes} setAttributes={setAttributes} panelRef={panelRef} updateFeatures={updateFeatures} />

                      {name == "html5-player/video" && (
                        <Fragment>
                          {/* <Streaming attributes={attributes} setAttributes={setAttributes} /> */}
                          {!source.includes(".mpd") && !source.includes(".m3u8") && (
                            <Fragment>
                              <Subtitle updateOption={updateOption} isPremium={isPremium} attributes={attributes} setAttributes={setAttributes} />
                              <Quality isPremium={isPremium} attributes={attributes} setAttributes={setAttributes} />
                            </Fragment>
                          )}
                          <PanelBody title={__("Speed", "h5vp")} initialOpen={false}>
                            <TextControl label={__("Speed", "h5vp")} value={speed.options} onChange={(options) => updateOption({ ...speed, options: options.split(",") }, "speed")} />
                          </PanelBody>
                        </Fragment>
                      )}
                      <Popup isPremium={isPremium} attributes={attributes} setAttributes={setAttributes} updateFeatures={updateFeatures} />
                      <Watermark isPremium={isPremium} attributes={attributes} setAttributes={setAttributes} handleFeatures={updateFeatures} />

                      <PanelBody title={__("Additional", "h5vp")} initialOpen={false}>
                        <BControlPro isPremium={isPremium} Component={TextControl} label="Additional ID" value={additionalID} onChange={(additionalID) => setAttributes({ additionalID })} />

                        <BControlPro
                          isPremium={isPremium}
                          Component={TextareaControl}
                          label={__("Additional CSS", "h5vp")}
                          value={additionalCSS}
                          onChange={(additionalCSS) => setAttributes({ additionalCSS })}
                        />
                      </PanelBody>
                    </Panel>
                  </span>
                )}
                {tab.name == "controls" && <BControls attributes={attributes} setAttributes={setAttributes} updateOption={updateOption} />}
                {tab.name == "style" && (
                  <span>
                    <Panel>
                      <PanelBody ref={panelRef}>
                        <UnitControl
                          label={__("Width", "h5vp")}
                          step={1}
                          value={plyr_wrapper.width}
                          onChange={(width) => updateStyle({ width }, "plyr_wrapper")}
                          isResetValueOnUnitChange={true}
                          default="100"
                          onUnitChange={handleUnitChange}
                        />
                        <UnitControl label={__("Round Corner", "h5vp")} value={plyr_wrapper.borderRadius} onChange={(borderRadius) => updateStyle({ borderRadius }, "plyr_wrapper")} />
                      </PanelBody>
                    </Panel>
                  </span>
                )}
              </span>
            );
          }}
        </TabPanel>
      </InspectorControls>
      {/* <Thumbs player={player} setAttributes={setAttributes} attributes={attributes} setThumbModel={setThumbModel} thumbModel={thumbModel} /> */}
    </Fragment>
  );
};

export default BSettings;
